var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTravelGuideRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.32 2.77671L13.32 0.555853H13.25C13.2034 0.550658 13.1565 0.550658 13.11 0.555853H12.88H12.75H12.68L7 2.72118L1.32 0.555853C1.16962 0.500789 1.00961 0.486169 0.853138 0.513196C0.69667 0.540223 0.548219 0.608125 0.420003 0.711313C0.290762 0.81349 0.185268 0.948348 0.112238 1.10474C0.039208 1.26114 0.000736953 1.43459 3.33353e-06 1.61076V17.1567C-0.000537828 17.3895 0.0648223 17.6166 0.186845 17.8059C0.308868 17.9952 0.481382 18.1371 0.680003 18.2116L6.68 20.4325C6.88145 20.5054 7.09855 20.5054 7.3 20.4325L13 18.3227L18.68 20.488C18.7862 20.504 18.8938 20.504 19 20.488C19.2091 20.4913 19.4132 20.417 19.58 20.277C19.7092 20.1748 19.8147 20.04 19.8878 19.8836C19.9608 19.7272 19.9993 19.5537 20 19.3776V3.83161C20.0005 3.59882 19.9352 3.37172 19.8132 3.18242C19.6911 2.99312 19.5186 2.8512 19.32 2.77671ZM6 17.8341L2 16.3572V3.15425L6 4.63112V17.8341ZM12 16.3572L8 17.8341V4.63112L12 3.15425V16.3572ZM18 17.8341L14 16.3572V3.15425L18 4.63112V17.8341Z",
    fill: "#AB0101"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTravelGuideRed);
export default __webpack_public_path__ + "static/media/travel_guide_red.04ab99542dfce5279cbeb2ec9b468c51.svg";
export { ForwardRef as ReactComponent };